<script setup>
import Card from '@/Components/Card/Card.vue';
import SiteLayout from '@/Layouts/Layout.vue';

import BlocklistLookupForm from '@/Pages/BlocklistLookup/BlocklistLookupForm.vue';
import Alert from '@/Components/Alert.vue';
import { TOOL_BLOCKLIST_LOOKUP, captureToolUsed } from '@/Common/Posthog.js';

defineProps({
  result: Object,
  ip: String
});

captureToolUsed({ tool: TOOL_BLOCKLIST_LOOKUP });
</script>

<template>
  <SiteLayout
    :title="$t('blocklist_lookup.show.blocklist_lookup', { ip: ip })"
    :description="$t('blocklist_lookup.index.blocklist_lookup_description')"
  >
    <BlocklistLookupForm :ip="ip" />
    <Card>
      <Alert
        v-if="!result.is_blacklisted"
        :title="$t('blocklist_lookup.show.is_not_blocklisted', { ip: ip })"
        variant="success"
      />

      <div v-else>
        <Alert
          :title="$t('blocklist_lookup.show.is_blocklisted', { ip: ip })"
          variant="danger"
        />

        <div class="mt-6 flex flex-col gap-2">
          <div class="flex justify-between sm:justify-start">
            <div class="w-1/2 font-bold">
              {{ $t('blocklist_lookup.show.blocklist') }}
            </div>
            <div class="font-bold">{{ $t('blocklist_lookup.show.code') }}</div>
          </div>

          <div
            v-for="item in result.blacklists"
            :key="item.blacklist"
            class="flex justify-between sm:justify-start"
          >
            <div class="w-1/2">{{ item.blacklist }}</div>
            <div>{{ item.code }}</div>
          </div>
        </div>
      </div>
    </Card>
  </SiteLayout>
</template>
